<div class="container-lg">
    <h1>Page introuvable</h1>
    
    <p class="p1-404">L'adresse que vous cherchez n'existe pas</p>
    <p class="p2-404">Vous pouvez retourner à la page principal</p>
    <a routerLink="/" class="lien-home-from-404">
        <button class="btn">Retour à la page d'accueil</button>
    </a>
</div>
